/**
 * iPhone / iPod / iPad / iPadOS（桌面 UA 的 iPad）
 * 用于媒体预览等与 WebKit 行为相关的分支（如 transform 作用在 video 上的差异）。
 */
export function isIosLikeDevice() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPhone|iPod|iPad/i.test(ua)) return true;
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) return true;
  return false;
}
